// extracted by mini-css-extract-plugin
export default {"header":"Header_header__OKWO7","section":"Header_section__BLgNs","iconBtn":"Header_iconBtn__ww234","menuIcon":"Header_menuIcon__itNZ4"};